export const indeterminate = (el, binding) => el.indeterminate = binding.value;
